export default "__VITE_ASSET__BfXEl5GI__"